export default __webpack_public_path__ + "static/media/gethereum-mascot-circle.530c86b2.png";